import * as React from 'react';
import { ComboBox, ComboBoxChangeEvent } from '@progress/kendo-react-dropdowns';
import { fetchApi } from '../services/api';

type Props = {
    callbackFromParent: (data: SchoolSearchResult) => void;
    className?: string;
    style?: {};
};

type State = {
    defaultValue: SchoolSearchResult | null;
    loading: boolean;
    opened: boolean;
    schoolResults: SchoolSearchResult[];
}

export interface SchoolSearchResult {
    SchoolId: number;
    SchoolName: string;
}

export default class SchoolComboBox extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            defaultValue: null,
            loading: false,
            opened: false,
            schoolResults: [],
        };

        this.getSchools();
    };

    onChange = (event: ComboBoxChangeEvent) => {
        this.props.callbackFromParent(event.target.value);
    }

    private getSchools() {
        fetchApi('api/School/List', {}, 'POST')
            .then((data: SchoolSearchResult[]) => {
                let _defaultSelectedSchool: SchoolSearchResult | undefined;
                const localStorageSchoolId = localStorage.getItem("SCHOOL_ID");
                if (localStorageSchoolId) {
                    _defaultSelectedSchool = data.find(x => x.SchoolId === parseInt(localStorageSchoolId))
                }

                this.setState({
                    defaultValue: _defaultSelectedSchool || null,
                    schoolResults: data,
                    loading: false
                });
                
                if (_defaultSelectedSchool) {
                    this.props.callbackFromParent(_defaultSelectedSchool);
                }
            });
    }

    public render() {
        return (
            <ComboBox
                defaultValue={this.state.defaultValue}
                data={this.state.schoolResults}
                onChange={this.onChange}
                loading={this.state.loading}
                style={this.props.style}
                className={this.props.className}
                allowCustom={true}
                placeholder="School"
                suggest={true}
                textField="SchoolName"
            />
        );
    }
}
